import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Empty,
  Popconfirm,
  Row,
  Table,
  Tooltip,
  Typography,
  message,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import InviteUser from "../Modals/InviteUser";
import { translate } from "../../locale";
import { useNavigate } from "react-router-dom";
import UserServices from "../../services/UserServices";
import { AdminContext } from "../../providers/AdminContext";
import Company from "../../services/CompanyServices";
import { TableHelper } from "../../helpers/TableHelper";
import ChangeRole from "../Modals/ChangeRole";
import logoImageBellCross from "../../assets/images/bell-cross.png";
import logoImageBell from "../../assets/images/bell.png";

const { Text } = Typography;

const SubscriptionCoordinators = ({ subscription, reload, onChange }) => {
  const [loading, setLoading] = useState(false);
  const [modalAddUser, setModalAddUser] = useState(false);
  const [showChangeRole, setShowChangeRole] = useState(false);
  const [users, setUsers] = useState(null);
  const navigate = useNavigate();
  const { user } = useContext(AdminContext);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingAllow, setLoadingAllow] = useState(false);
  const [loadingDisallow, setLoadingDisallow] = useState(false);
  const hasSelected = selectedRowKeys.length > 0;
  const [isSuper, setIsSuper] = useState(false);

  useEffect(() => {
    if (user !== null && user !== undefined) {
      setIsSuper(user.user.rol === "eira-super-admin");
    }
  }, [user]);

  useEffect(() => {
    if (subscription !== null && subscription.id !== undefined) {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      loadData(data);
      setIsSuperAdmin(user.user.rol === "eira-super-admin");
    }
  }, [subscription, reload]);

  useEffect(() => {
    let data = {
      page_size: tableParams.pagination.pageSize,
      page_num: tableParams.pagination.current,
    };
    const sorter = TableHelper.sorter(tableParams);
    if (sorter !== null) {
      data = { ...data, order_by: sorter };
    }
    loadData(data);
  }, [JSON.stringify(tableParams)]);

  const loadData = async (data) => {
    if (subscription.id === undefined) return;
    setLoading(true);
    try {
      const res = await UserServices.getSubscriptionUser(
        data,
        subscription.id,
        "eira-company-coordinator"
      );

      if (res.status >= 200 && res.status < 300) {
        const _professionals = res.data.users.map((pro) => ({
          id: pro.profile.user.id,
          username: pro.profile.user.username,
          first_name: pro.profile.first_name,
          last_name: pro.profile.last_name,
          rol: pro.profile.user.rol,
          user: pro.profile.user,
          receive_email_new_users: pro.receive_email_new_users,
        }));
        setUsers(_professionals);
        setTotal(res.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const addUser = () => {
    setModalAddUser(true);
  };
  const handleCancelAdd = () => {
    setModalAddUser(false);
  };
  const handleCompleteAdd = (data) => {
    setModalAddUser(false);
  };

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 150,
      render: (value, record, index) => (
        <div className="flex space-x-4 justify-center">
          {isSuperAdmin && (
            <Popconfirm
              title={
                <>
                  ¿Está seguro de que quiere desvincular este usuario de la
                  suscripción?
                  <br />
                  Esta acción no se puede deshacer.
                </>
              }
              okText="Si"
              cancelText="No"
              onConfirm={() => {
                deleteUserFromCompany(record.username);
              }}
            >
              <Tooltip title="Eliminar" color="blur">
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  size="small"
                  className="border-0"
                />
              </Tooltip>
            </Popconfirm>
          )}
          <Tooltip title={translate("Editar")} color="blur">
            <Button
              shape="circle"
              icon={<EditOutlined />}
              size="small"
              className="border-none"
              onClick={() => {
                navigate(
                  `/admin/buscar-paciente/${record.username}/personal-details`
                );
              }}
            />
          </Tooltip>

          <Tooltip title={translate("Cambiar rol")}>
            <Button
              type="text"
              icon={<UserSwitchOutlined />}
              size="small"
              className="border-0"
              onClick={() => {
                setShowChangeRole(record);
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: translate("Usuario"),
      dataIndex: "username",
      key: "username",
      render: (_, record) => {
        if (record.user.provider === "cronic") {
          return record.username;
        }
        return (
          <a
            onClick={() =>
              navigate(
                `/admin/buscar-paciente/${record.user.username}/personal-details`
              )
            }
            className="text-black hover:text-custom_primary"
          >
            {record.username}
          </a>
        );
      },
      sorter: (a, b) => {
        if (a.username < b.username) return -1;
        if (a.username > b.username) return 1;
        return 0;
      },
    },
    {
      title: translate("Nombre"),
      dataIndex: "first_name",
      key: "first_name",
      sorter: (a, b) => {
        if (a.first_name < b.first_name) return -1;
        if (a.first_name > b.first_name) return 1;
        return 0;
      },
    },
    {
      title: translate("Apellido"),
      dataIndex: "last_name",
      key: "last_name",
      sorter: (a, b) => {
        if (a.last_name < b.last_name) return -1;
        if (a.last_name > b.last_name) return 1;
        return 0;
      },
    },
    {
      title: translate("Rol"),
      dataIndex: "rol",
      key: "rol",
      render: (value, record, index) =>
        translate(UserServices.matchRole(record.rol)),
      sorter: (a, b) => {
        if (a.rol < b.rol) return -1;
        if (a.rol > b.rol) return 1;
        return 0;
      },
    },
    {
      title: translate("Recibir Notificaciones"),
      dataIndex: "receive_email_new_users",
      key: "receive_email_new_users",
      render: (value, record, index) =>
        translate(record.receive_email_new_users ? "Si" : "No"),
      sorter: (a, b) => {
        if (a.receive_email_new_users < b.receive_email_new_users) return -1;
        if (a.receive_email_new_users > b.receive_email_new_users) return 1;
        return 0;
      },
    },
  ];

  const deleteUserFromCompany = async (username) => {
    setLoading(true);
    try {
      const res = await UserServices.deleteSubscriptionUser(
        subscription.id,
        username,
        true,
        subscription.enterprise.id
      );
      if (res.status >= 200 && res.status < 300) {
        loadData();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setUsers([]);
    }
  };

  const onChangeRoleComplete = (oldRole, newRole) => {
    if (onChange) {
      onChange(oldRole, newRole);
    }
    setShowChangeRole(false);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const receiveEmailNewUserPut = (allow) => {
    if (allow) {
      setLoadingAllow(true);
    } else {
      setLoadingDisallow(true);
    }
    try {
      const _data = {
        username: "",
        subscription_id: subscription.id,
        enterprise_id: subscription.enterprise.id,
        receive_email_new_users: allow,
      };
      console.log("selectedRowKeys", selectedRowKeys);
      const inviteResponse = selectedRowKeys.map((username) =>
        UserServices.receiveEmailNewUserPut({ ..._data, username })
      );
      Promise.allSettled(inviteResponse).then((response) => {
        console.log("response", response);
        const allRs = response
          .map((rs) => {
            if (rs.status === "fulfilled" && rs.value.status >= 300) {
              const data = JSON.parse(rs.value.config.data);
              return data.username;
            }
          })
          .filter((f) => f !== undefined);
        if (allRs.length > 0) {
          message.error(
            `No se pudieron cambiar los permisos de los siguientes usuarios (${allRs.join(
              ", "
            )})`
          );
        } else {
          message.success(
            translate(`Los permisos han sido actualizados correctamente`)
          );
          loadData();
        }
        setSelectedRowKeys([]);
      });
      setLoading(false);
    } catch (e) {
      console.log(e);
      message.error(e.message);
    } finally {
      setSelectedRowKeys([]);
      if (allow) {
        setLoadingAllow(false);
      } else {
        setLoadingDisallow(false);
      }
      // setTimeout(loadData, 100);
    }
  };

  return (
    <Row gutter={16}>
      <Col span="24" className="mb-6">
        <Tooltip
          placement="topLeft"
          title={
            subscription?.modules && subscription.modules.length === 0
              ? translate("La suscripción no tiene modulos")
              : null
          }
          className="rounded"
        >
          <Button
            onClick={addUser}
            className="bg-white text-custom_darkgray hover:text-custom_primary hover:border-custom_primary mr-6"
            disabled={
              subscription?.modules && subscription.modules.length === 0
            }
          >
            {translate("Invitar coordinador")}
          </Button>
        </Tooltip>
        <InviteUser
          subscriptionId={subscription && subscription.id}
          visible={modalAddUser}
          onCancel={handleCancelAdd}
          onComplete={handleCompleteAdd}
          rol={"coordinator"}
          enterpriseId={subscription?.enterprise && subscription.enterprise.id}
        />
      </Col>
      <Col span="24" className="space-x-4 mb-2">
        <Tooltip title={translate("Recibir notificaciones")}>
          <Button
            type="primary"
            onClick={() => receiveEmailNewUserPut(true)}
            disabled={
              !hasSelected ||
              loadingAllow ||
              (user.user.username != selectedRowKeys && !isSuper)
            }
            loading={loadingAllow}
            icon={<img src={logoImageBell} className="h-4" />}
            ghost
          />
        </Tooltip>
        <Tooltip title={translate("No recibir notificaciones")}>
          <Button
            type="primary"
            onClick={() => receiveEmailNewUserPut(false)}
            disabled={
              !hasSelected ||
              loadingAllow ||
              (user.user.username != selectedRowKeys && !isSuper)
            }
            loading={loadingDisallow}
            icon={<img src={logoImageBellCross} className="h-4" />}
            ghost
          />
        </Tooltip>
      </Col>
      <Col span="24">
        <Table
          rowKey={(i) => i.username}
          rowSelection={rowSelection}
          dataSource={users}
          columns={columns}
          locale={{
            emptyText: <Empty description={translate("No hay datos")} />,
            sortTitle: translate("Ordenar"),
            triggerDesc: translate("Ordenar (descendente)"),
            triggerAsc: translate("Ordenar (ascendente)"),
            cancelSort: translate("Cancelar orden"),
          }}
          pagination={{ ...tableParams.pagination, total: total }}
          onChange={handleTableChange}
        />
        <ChangeRole
          data={showChangeRole}
          onComplete={onChangeRoleComplete}
          onCancel={() => setShowChangeRole(false)}
          enterpriseId={subscription?.enterprise?.id}
        />
      </Col>
    </Row>
  );
};

export default SubscriptionCoordinators;
